import React, { useState } from "react";
import emailjs from "@emailjs/browser";
import "./ContactForm.css";

const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    country: "",
    message: "",
  });

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const validateEmail = (email) => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!validateEmail(formData.email)) {
      setError("Por favor, ingresa un email válido.");
      return;
    }

    setIsLoading(true);
    setError("");

    const emailParams = {
      from_name: formData.name,
      from_email: formData.email,
      phone: formData.phone,
      country: formData.country,
      message: formData.message,
    };

    const serviceID = "popla-web-mail-sender";
    const templateID = "contact_form_popla";
    const userID = "user_s4ksp8kthXIPpoKDWLJp9";

    emailjs
      .send(serviceID, templateID, emailParams, userID)
      .then(() => {
        alert("Mensaje enviado con éxito");
        setFormData({ name: "", email: "", phone: "", country: "", message: "" });
      })
      .catch((error) => {
        console.error("Error al enviar el mensaje:", error);
        setError("Ocurrió un error al enviar el mensaje, intenta nuevamente.");
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <div className="contact-form-container">
      <h2 className="form-title">
        SI QUIERES CONTACTARTE CON NOSOTROS, AQUÍ DEBAJO PUEDES <br /> ENVIARNOS UN FORMULARIO, O ACERCARTE A NUESTRAS OFICINAS.
      </h2>

      {error && <p className="error-message">{error}</p>}

      <form className="contact-form" onSubmit={handleSubmit}>
        <div className="form-left">
          <input
            type="text"
            name="name"
            placeholder="Nombre"
            className="input-field"
            value={formData.name}
            onChange={handleChange}
            required
          />
          <input
            type="email"
            name="email"
            placeholder="Email"
            className="input-field"
            value={formData.email}
            onChange={handleChange}
            required
          />
          <input
            type="tel"
            name="phone"
            placeholder="Teléfono"
            className="input-field"
            value={formData.phone}
            onChange={handleChange}
          />
          <input
            type="text"
            name="country"
            placeholder="País"
            className="input-field"
            value={formData.country}
            onChange={handleChange}
          />
        </div>
        <div className="form-right">
          <textarea
            name="message"
            placeholder="Consulta..."
            className="textarea-field"
            value={formData.message}
            onChange={handleChange}
            required
          ></textarea>
        </div>
      </form>
      <button type="submit" className="submit-button" onClick={handleSubmit} disabled={isLoading}>
        {isLoading ? "Enviando..." : "ENVIAR"}
      </button>
    </div>
  );
};

export default ContactForm;